// extracted by mini-css-extract-plugin
module.exports = {"container":"_2tGLqfAg","inputWrapper":"_3L6Lpnx6","invalidInputWrapper":"_17rmHSwd","suggestionsContainer":"_2B1MedMu","item":"_3cAwZQKM","itemHovered":"Cpv8INaR"};